import { useTheme } from '@mui/material'
import type { Breakpoint } from '@mui/system'
import { useMemo } from 'react'

import { useWindowSize } from './useWindowSize'

// ///////////////////////
// MARK: EXPORTS
export function useBreakpoint(
  breakpoint: Breakpoint,
  comparator: 'lt' | 'lte' | 'gt' | 'gte' | 'eq' = 'gt',
): [active: boolean] {
  const theme = useTheme()
  const [width] = useWindowSize()

  const result = useMemo(() => {
    const breakpointWidth = theme.breakpoints.values[breakpoint]

    switch (comparator) {
      case 'lt': {
        return width < breakpointWidth
      }
      case 'lte': {
        return width <= breakpointWidth
      }
      case 'gt': {
        return width > breakpointWidth
      }
      case 'gte': {
        return width >= breakpointWidth
      }
      case 'eq': {
        return width === breakpointWidth
      }
      default: {
        return false
      }
    }
  }, [breakpoint, comparator, theme.breakpoints.values, width])

  return [result]
}
